var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('script',{attrs:{"id":_vm.id,"type":"text/plain"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }